import { type App, type ComponentPublicInstance, nextTick } from 'vue'
import type { Rogue } from '@/js/services/Rogue'

export function configureErrorHandler(app: App, rogue: Rogue) {
  app.config.errorHandler = (err: unknown, instance: ComponentPublicInstance | null, info: string) => {
    const elPath: string[] = []

    if (instance) {
      let tgt: ComponentPublicInstance | null = instance
      while (tgt) {
        const name = tgt.$options?.name || 'Anonymous'
        elPath.push(name)
        tgt = tgt.$parent
      }
    } else {
      // These seem to be pretty serious errors.
      // Check if Vue is still working. Sometimes, Vue stops responding to listeners...
      const now = Date.now()
      rogue.observeData.watcherTest = now
      rogue.log.info('After unknown error, setting watcherTest to true...')

      setTimeout(() => {
        nextTick(() => {
          const val = document.getElementById('app')?.getAttribute('data-watcher-test')
          if (!val || parseInt(val, 10) < now) {
            rogue.log.error('Error caused watchers to break, enabling full page reload mode...', err as Error)
            // This will cause the next link click to perform a full page reload
            rogue.observeData.unrecoverableError = true
          }
        })
      }, 300)
    }

    rogue.log.error('Vue exception handler', err as Error, {
      info,
      route     : instance?.$route?.name,
      component : instance?.$options.name,
      path      : elPath.join(' > '),
    })
  }
}
